import { render, staticRenderFns } from "./CofDetailView.vue?vue&type=template&id=750a8e80&scoped=true"
import script from "./CofDetailView.vue?vue&type=script&lang=js"
export * from "./CofDetailView.vue?vue&type=script&lang=js"
import style0 from "./CofDetailView.vue?vue&type=style&index=0&id=750a8e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750a8e80",
  null
  
)

export default component.exports